import { amountToDisplayValue, Flex, Link, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { ReactComponent as PaymentSummaryWaveImage } from '../../../../../../../../assets/images/imported-invoice-payment-summary-wave.svg'
import { EmberRoute } from '../../../../../../../../enums/emberRoute'
import { useEmberRouteUrl } from '../../../../../../../../hooks/routing/useEmberRouteUrl'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { useOrganizationSource } from '../../../../../../../../hooks/useOrganizationSource'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { importedInvoicePaymentStatusToVariant } from '../../../../../../constants/importedInvoicePaymentStatusToVariant'
import { ImportedInvoiceApproved } from '../../../../../../types/importedInvoiceApproved'
import { ImportedInvoicePaymentStatus } from '../../../../../../types/importedInvoicePaymentStatus'
import * as Styled from './styles'

interface ImportedInvoicePaymentSummaryProps {
  approved: ImportedInvoiceApproved
  paymentStatus: ImportedInvoicePaymentStatus
}

export const ImportedInvoicePaymentSummary = ({
  approved,
  paymentStatus,
}: ImportedInvoicePaymentSummaryProps): ReactElement => {
  const { isSourceBilly } = useOrganizationSource()
  const { url: emberCustomerUrl } = useEmberRouteUrl(EmberRoute.ContactsCustomer, approved.contactId)
  const { url: clientUrl } = useOrganizationViewUrl(
    reactRoute.organization.clients.getViewClientRoute(approved.contactId),
  )

  const customerUrl = isSourceBilly ? emberCustomerUrl : clientUrl
  const { summaryColor } = importedInvoicePaymentStatusToVariant[paymentStatus]

  return (
    <div>
      <Styled.ImportedInvoicePaymentSummaryContent summaryColor={summaryColor}>
        <Flex alignItems="center" flexDirection="column" gap={Spacing.S8}>
          <Text as="p" variant="h2">
            {amountToDisplayValue(approved.amount)}{' '}
            <Text as="span" inline variant="h4">
              {approved.currencyId}
            </Text>
          </Text>
          <Text variant="bodyMD" weight="semiBold">
            <Link to={customerUrl} withAnimation>
              {approved.customerName}
            </Link>
          </Text>
        </Flex>
      </Styled.ImportedInvoicePaymentSummaryContent>
      <Styled.ImportedInvoicePaymentSummaryWaveWrapper summaryColor={summaryColor}>
        {/* The asset has `preserveAspectRatio="none"`: it keeps its height and stretches to the panel width. */}
        <PaymentSummaryWaveImage aria-hidden width="100%" />
      </Styled.ImportedInvoicePaymentSummaryWaveWrapper>
    </div>
  )
}
